module.exports = __webpack_public_path__ + "static/media/logo.55312104.svg";